/* istanbul ignore file */
import { StyledTooltipHeader } from './Tooltip.style';
import _, { startCase } from 'lodash';
import { RESOURCE_TYPES } from '../../../resource_types';
import TotalFteIcon from './icons/total-fte.svg';
import EstCostIcon from './icons/est-cost.svg';
import JiraIssuesIcon from './icons/jira-issues.svg';
import JiraEpicsIcon from './icons/jira-epics.svg';
import { getRoundedFte } from '../../../resource-allocation.formatters';
import { mapPmProviderToViewer } from 'common/hooks/pm/usePmViewer/usePmViewer.utils';

const TooltipHeader = ({ event, pointData, resourceType, raCost }) => {
  const isInitiative = resourceType.key === RESOURCE_TYPES.JIRA_INITIATIVES.key;
  const issuesCount =
    _.get(
      // deprecated will be removed next PR
      pointData,
      isInitiative ? 'epics_count' : 'issues_count'
    ) ||
    _.get(pointData, 'associated_count') ||
    0;

  const pmViewer = mapPmProviderToViewer(resourceType.pmProvider);

  const issuesText = isInitiative ? 'Epics' : startCase(pmViewer.ticket.plural);
  const IssuesIcon = isInitiative ? JiraEpicsIcon : JiraIssuesIcon;

  const effortFte = _.get(pointData, 'effort_fte');
  const roundEffortFte = getRoundedFte(effortFte);

  const roundFtePercentage = getRoundedFte(pointData?.['effort_p']);

  const pointPeriod = {
    before: pointData?.end_period,
    after: pointData?.start_period
  };

  const estCostValue = raCost.calculateCostByFte({
    effortFte,
    period: pointPeriod
  });

  return (
    <StyledTooltipHeader data-cy='tooltip-header'>
      <div className='stats total-fte'>
        <img className='icon' src={TotalFteIcon} />
        <div className='primary'>
          {roundEffortFte}({roundFtePercentage}%)
        </div>
        <div className='secondary'>of total FTE</div>
      </div>
      {raCost.isEnabled && (
        <div className='stats est-cost'>
          <img className='icon' src={EstCostIcon} />
          <div className='primary'>{raCost.formatToString(estCostValue)}</div>
          <div className='secondary'>Est. Cost</div>
        </div>
      )}
      <div className='stats jira-issues'>
        <img className='icon' src={IssuesIcon} />
        <div className='primary'>{issuesCount}</div>
        <div className='secondary'>{issuesText}</div>
      </div>
    </StyledTooltipHeader>
  );
};

export default TooltipHeader;
